import { useLanderConfig } from "../commons/ConfigContext";
import { System } from "../commons/Constants";
import { ExperimentIds } from "../commons/constants/experiment";
import { isControlCohort } from "./helper";

/**
 * Optimized-keywords experiment (ParkWeb, PARKING-5154).
 *
 * The treatment arm renders the PW-provided high-value `optimizedKeywords` as Yahoo
 * Partner Supplied Terms (the correct channel that replaced the old `seedTerm` path).
 * The Yahoo source tag used for RPM measurement is stamped by the API on
 * `yahoo.typeTag` (pwYahooOptKwControl / pwYahooOptKwTreatment), so this hook only
 * reports treatment membership and dispatches nothing.
 */
export function useOptimizedKeywordsExperiment() {
  const { landerConfig } = useLanderConfig();
  const { experiment: { key, cohort } = {} } = landerConfig;

  const inExperiment = key === ExperimentIds.yahooOptimizedKeywords;
  const isParkWeb = landerConfig.system === System.PARKWEB;
  const inOptimizedKeywordsTreatment =
    inExperiment && isParkWeb && !!cohort && !isControlCohort(cohort);

  return { inOptimizedKeywordsTreatment };
}
